import { useMemo, useState } from 'react'
import M5CloseWorkOrderPartRequestsModal from './M5CloseWorkOrderPartRequestsModal'
import ProgressIconThreeFourths from '@/buyers/components/Icons/ProgressIconThreeFourths'
import { useGetWorkOrderPartRequestsQuery } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'

const M5CloseWorkOrderPartRequests = ({ workOrder }: { workOrder: string }) => {
  const gqlClient = useGqlClient()

  const { data } = useGetWorkOrderPartRequestsQuery({
    client: gqlClient,
    variables: { workOrderId: workOrder },
  })

  const [open, setOpen] = useState(false)

  const openPartRequests = useMemo(
    () => data?.getWorkOrderPartRequests.filter((pr) => !pr.completed),
    [data]
  )

  return (
    <>
      <M5CloseWorkOrderPartRequestsModal
        workOrder={workOrder}
        open={open}
        onClose={() => setOpen(false)}
      />
      {openPartRequests && openPartRequests.length > 0 && (
        <button
          className="p-1 flex justify-center items-center rounded-full hover:bg-gray-200 transition duration-75"
          onClick={() => setOpen(true)}
        >
          <ProgressIconThreeFourths className="w-5 h-5 text-blue-600" />
        </button>
      )}
    </>
  )
}

export default M5CloseWorkOrderPartRequests
